'use client';

import { Button } from '@/components/ui/button';
import { Dialog, DialogClose, DialogContent } from '@/components/ui/dialog';
import { useIsMobile } from '@/hooks/use-is-mobile';
import { cn } from '@/lib/utils';
import Image from 'next/image';
import { useState } from 'react';
import ReactPlayer from 'react-player';
import classes from './aboutUs.module.css';

export const Banner = () => {
  const { isMobile } = useIsMobile();
  const [showVideo, setShowVideo] = useState(false);
  const btnWidth = isMobile ? '15' : '18';
  const btnHeight = isMobile ? '18' : '22';
  return (
    <div
      className='relative mb-[0] h-[340px] w-full lg_mb-[80px] lg_h-[600px]'
      style={{
        backgroundImage: `url(${isMobile ? '/about-us/banner_m.png' : '/about-us/banner.webp'})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* <Image
        src={isMobile ? '/about-us/banner_m.png' : '/about-us/banner.webp'}
        alt='about-us-new-page'
        width={1920}
        height={800}
        className=' w-full'
      /> */}

      <div className='absolute left-0 top-0 h-full w-full'>
        <div className='container mx-auto flex h-full flex-col items-center justify-center lg_items-start'>
          <h1
            className=' text-center font-teko-medium text-[30px] font-medium uppercase leading-[40px] text-white lg_text-left lg_text-[40px]'
            style={{ textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)' }}
          >
            About Us
          </h1>
          <p
            className='text-center font-roboto-regular text-[16px] font-medium leading-[24px] text-white lg_text-left lg_font-roboto-medium lg_text-[18px]'
            style={{ textShadow: '0px 2px 10px rgba(0, 0, 0, 0.4)' }}
          >
            Discover the nature and connect with the world.
          </p>
          <div className='flex justify-center lg_justify-start'>
            <Button
              variant='secondary'
              className={cn(
                'mt-[40px] h-[40px] w-[132px] rounded-full bg-white font-roboto-medium text-[16px] capitalize text-black lg_h-[50px] lg_w-[180px] lg_text-[18px]',
                classes.playButton,
              )}
              onClick={() => setShowVideo(true)}
            >
              <Image
                src='/icons/play.svg'
                alt='play icon'
                width={btnWidth}
                height={btnHeight}
                className='mr-2'
              />
              <Image
                src='/icons/playWhite.svg'
                alt='play icon'
                width={btnWidth}
                height={btnHeight}
                className='mr-2'
              />
              play video
            </Button>
          </div>
        </div>
      </div>

      <Dialog
        open={showVideo}
        onOpenChange={setShowVideo}
      >
        <DialogContent className='max-w-4xl bg-black p-0'>
          <DialogClose className='absolute -top-10 right-0 text-white' />
          <ReactPlayer
            url='https://www.hisea.com/media/wysiwyg/homepage/adventurer.mp4'
            width='100%'
            height='100%'
            controls
            playing
          />
        </DialogContent>
      </Dialog>
    </div>
  );
};
